/**
 * Skeleton — a grey shimmering placeholder shown while data loads.
 *
 * WHY NOT JUST A SPINNER
 * A spinner says "something is loading" but the page jumps when content
 * arrives. A skeleton shows the SHAPE of what is coming, so the layout is
 * stable and the wait feels shorter. This is what every polished app does —
 * and it is a big part of why Rocket07 will feel "fast" even on slow WiFi.
 */

import { cn } from '@/lib/cn';

export function Skeleton({ className }) {
  return <div className={cn('shimmer rounded-md', className)} aria-hidden="true" />;
}

/** A ready-made product-card skeleton, so loading grids match loaded grids. */
export function ProductCardSkeleton() {
  return (
    <div className="rounded-xl border border-line bg-surface p-3 shadow-card">
      <Skeleton className="mb-3 aspect-square w-full rounded-lg" />
      <Skeleton className="mb-2 h-3 w-1/3" />
      <Skeleton className="mb-2 h-4 w-full" />
      <Skeleton className="mb-3 h-4 w-2/3" />
      <Skeleton className="h-9 w-full rounded-lg" />
    </div>
  );
}

export default Skeleton;
